import abbreviationState from "@/assets/abbreviation-state.json"

const state = {
    questionBy: undefined, // { 'state', 'capital', 'random' }
    questionOrder: undefined, // { 'alphabetic', 'random' }
    numberOfOptions: undefined, // { 3, 5, 10}
    showHints: undefined, // { true, false }
    statesIncluded: [], // empty array or list of state abbreviations
}

const getters = {
    questionBy: (state) => { return state.questionBy },
    questionOrder: (state) => { return state.questionOrder },
    numberOfOptions: (state) => { return state.numberOfOptions },
    showHints: (state) => { return state.showHints },
    statesIncluded: (state) => { return state.statesIncluded },
};

const mutations = {
    SET_QUESTION_BY(state, questionBy) {
        state.questionBy = questionBy
    },

    SET_QUESTION_ORDER(state, questionOrder) {
        state.questionOrder = questionOrder
    },

    SET_NUMBER_OF_OPTIONS(state, numberOfOptions) {
        state.numberOfOptions = numberOfOptions
    },

    SET_SHOW_HINTS(state, showHints) {
        state.showHints = showHints
    },

    SET_STATES_INCLUDED(state, statesIncluded) {
        state.statesIncluded = statesIncluded
    },
};

const actions = {
    initialize: function ({ dispatch }, config) {
        dispatch("setQuestionBy", config.questionBy)
        dispatch("setQuestionOrder", config.questionOrder)
        dispatch("setNumberOfOptions", config.numberOfOptions)
        dispatch("setShowHints", config.showHints)

        let statesToInclude = new Set()
        if (config.statesIncluded.length > 0) {
            statesToInclude = new Set(config.statesIncluded)
        } else {
            statesToInclude = new Set(Object.keys(abbreviationState))
        }
        dispatch("setStatesIncluded", [...statesToInclude])
    },

    setQuestionBy({ commit }, questionBy) {
        commit("SET_QUESTION_BY", questionBy);
    },

    setQuestionOrder({ commit }, questionOrder) {
        commit("SET_QUESTION_ORDER", questionOrder);
    },

    setNumberOfOptions({ commit }, numberOfOptions) {
        commit("SET_NUMBER_OF_OPTIONS", numberOfOptions);
    },

    setShowHints({ commit }, showHints) {
        commit("SET_SHOW_HINTS", showHints);
    },

    setStatesIncluded({ commit }, statesIncluded) {
        commit("SET_STATES_INCLUDED", statesIncluded);
    },
};

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;
